import React, { FunctionComponent } from 'react';
import { css } from 'emotion';

const ColorCircle: FunctionComponent<{getBackgroundColor: () => string; id: string}> = ({ getBackgroundColor, id }) => {
  const backgroundHex = getBackgroundColor();
  const isValidHex = /^([0-9A-F]{3}){1,2}$/i.test(backgroundHex);
  const colorCss = {
    backgroundColor: `#${backgroundHex}`
  };
  return (
    <div
      className={`edit-tab-sidebar-color-display-circle ${css(colorCss)} ${isValidHex ? '' : 'no-value'}`}
      id={id}
    />
  );
};

export default ColorCircle;
